module.exports = __webpack_public_path__ + "static/media/kayak_new.b0775718.png";